import * as React from 'react'
import cx from 'classnames'
import styles from './SectionEmpty.sass'

interface SectionEmptyProps {
  children?: React.ReactNode
}

export default function SectionEmpty({ children }: SectionEmptyProps) {
  return <div className={cx(styles.root)}>{children}</div>
}
